import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ArticleCard = ({ article }) => (
  <Link
    to={`/${article.hub}/${article.slug}`}
    className="group card-soft p-6 md:p-7 flex flex-col gap-3 h-full transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_-16px_rgba(36,40,43,0.25)]"
    data-testid={`article-card-${article.slug}`}
  >
    <span className="eyebrow">{article.hub === "direction" ? "Direction" : "Understanding"} · {article.reading_minutes} min read</span>
    <h3 className="text-xl font-semibold leading-snug group-hover:text-teal transition-colors">{article.title}</h3>
    <p className="text-ink-soft text-[0.97rem]">{article.summary}</p>
    <span className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-teal pt-2">Read <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" /></span>
  </Link>
);
